import React, { useEffect, useState } from 'react';
import Header from './components/Header.jsx';
import Hero from './components/Hero.jsx';
import VisionMission from './components/VisionMission.jsx';
import WhyChooseUs from './components/WhyChooseUs.jsx';
import Gallery from './components/Gallery.jsx';
import Certifications from './components/Certifications.jsx';
import Industries from './components/Industries.jsx';
import InquiryBanner from './components/InquiryBanner.jsx';
import Footer from './components/Footer.jsx';
import './index.css';
import AboutUs from './components/AboutUs.jsx';
import WhyAnuFlowControl from './components/WhyAnuFlowControl.jsx';
import Products from './components/Products.jsx';
import GateValves from './components/GateValves.jsx';
import GlobeValves from './components/GlobeValves.jsx';
import TrunnionBallValves from './components/TrunnionBallValves.jsx';
import SwingCheckValves from './components/SwingCheckValves.jsx';
import DualPlateCheckValves from './components/DualPlateCheckValves.jsx';
import FloatingBallValves from './components/FloatingBallValves.jsx';
import ButterflyValves from './components/ButterflyValves.jsx';
import ContactUs from './components/ContactUs.jsx';
import IndustriesServed from './components/IndustriesServed.jsx';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// ScrollToTop component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function Home() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleSmoothScroll = (e) => {
      if (e.target.matches('a[href^="#"]')) {
        e.preventDefault();
        const targetId = e.target.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    return () => document.removeEventListener('click', handleSmoothScroll);
  }, []);

  return (
    <div className="app">
      <Header />
      <Hero />
      <VisionMission />
      <WhyChooseUs />
      {/* <Gallery /> */}
      <Certifications />
      <Industries />
      <InquiryBanner />
      <Footer />
      {scrollY > 300 && (
        <button 
          className="scroll-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            background: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            cursor: 'pointer',
            fontSize: '1.2rem',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(220, 38, 38, 0.3)',
            transition: 'all 0.3s ease'
          }}
        >
          ↑
        </button>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/why-anuflowcontrol" element={<WhyAnuFlowControl />} />
        <Route path="/products" element={<Products />} />
        <Route path="/gate-valves" element={<GateValves />} />
        <Route path="/globe-valves" element={<GlobeValves />} />
        <Route path="/trunnion-ball-valves" element={<TrunnionBallValves />} />
        <Route path="/swing-check-valves" element={<SwingCheckValves />} />
        <Route path="/dual-plate-check-valves" element={<DualPlateCheckValves />} />
        <Route path="/floating-ball-valves" element={<FloatingBallValves />} />
        <Route path="/butterfly-valves" element={<ButterflyValves />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/industries-served" element={<IndustriesServed />} />
      </Routes>
    </Router>
  );
}

export default App;
